import { Button, Form, Input, Select, Radio } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import {
  FundAccountFilter,
  getMasterSettingsData,
  SelectPayload,
  SelectList,
  SourceAppNamelist,
  getSourceAppNames,
  MstRequest,
  getFundAccountMapping,
} from 'api/master';
import { FileExcelFilled } from '@ant-design/icons';

import FundAccountList from '../FundAccountList';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
const fundMappingFilter: FundAccountFilter = {};
const mstRequest: MstRequest = {};
const initPartners: SelectList[] = [];
// const initSelectResp: SelectResponse = {
//     data: [],
// };
const Filter = () => {
  const { Option } = Select;
  const [form] = Form.useForm<FundAccountFilter>();
  const [filter, setFilter] = useState(fundMappingFilter);
  const [statusList, setStatusList] = useState<SelectList[]>(initPartners);
  const [statusId, setStatusId] = useState<number | undefined>();
  const [_sourceId] = useState(0);
  //const [sources, setSource] = useState(initSelectResp);
  const [sourceAppNames, setSourceAppNames] = useState<SourceAppNamelist[]>([]);
  const [loanType, setLoanType] = useState<number | undefined>(); // State to store the selected Loan Type value

  const isAdmin = sessionStorage.getItem('isAdmin');
  useEffect(() => {
    fetchSourceAppNames();
    const statusPayload: SelectPayload = {
      sKey: 'LoanType',
    };
    debugger;
    getMasterSettingsData(statusPayload).then((res) => {
      setStatusList(res.data);
    });
    console.log(statusId, setLoanType);
  }, []);

  const fetchSourceAppNames = async () => {
    try {
      debugger;
      mstRequest.userName = sessionStorage.getItem('user')?.toString();
      mstRequest.isActive = true;
      mstRequest.pageNo = 0;
      mstRequest.pageSize = 0;
      mstRequest.roleId = '';

      const response = await getSourceAppNames(mstRequest);
      console.log('Source application names:', response.data);
      setSourceAppNames(response.data);
    } catch (error) {
      console.error('Error fetching source application names:', error);
    }
  };

  const handleSubmit = useCallback(
    async (values: FundAccountFilter) => {
      debugger;
      values.pageNo = 0;
      values.pageSize = 10;
      let updatedValues = { ...values };
      setFilter(updatedValues);
    },
    [form]
  );

  function getFullDate(date: string) {
    if (date != null) {
      const dateMoment = moment(new Date(date)).format('DD/MM/YYYY HH:mm:ss');
      return dateMoment;
    }
  }

  function handleDownload(_e: any) {
    debugger;
    const values: FundAccountFilter = form.getFieldsValue();
    const filteredValues: FundAccountFilter = {
      ...values,
      isExtract: true,
    };
    if (filteredValues.isActive == false) {
      filteredValues.isActive = false;
    } else {
      filteredValues.isActive = true;
    }
    // getFundAccountMapping(filteredValues).then((_x) => {
    //     const dashboardData = _x.data.data;
    //     if (dashboardData.length <= 0) {
    //         message.error("No Result Extrated");
    //     } else {
    //         // Format date before generating CSV
    //         const formattedData = dashboardData.map(item => ({
    //             ...item,
    //             CreatedOn: item.CreatedOn ? moment(item.CreatedOn).format('YYYY-MM-DD HH:mm') : null
    //         }));
    //         const csvConfig = mkConfig({ useKeysAsHeaders: true, filename: "FundAccount-Report" });
    //         const csv = generateCsv(csvConfig)(formattedData);
    //         download(csvConfig)(csv);
    //     }
    // });

    getFundAccountMapping(filteredValues).then((_x) => {
      let settings = {
        fileName: 'FundAccount-Report',
        extraLength: 3,
        writeMode: 'writeFile',
        writeOptions: {},
        RTL: false,
      };
      const content = _x.data?.data || [];
      const updatedData = content.map((item: any, index: number) => ({
        ...item,
        CreatedOn: getFullDate(item.CreatedOn),

        ROWNUM: index + 1,
      }));

      let data = [
        {
          sheet: 'Sheet 1',
          columns: [
            { label: 'ROWNUM', value: 'ROWNUM' },
            { label: 'FundAccMapID', value: 'FundAccMapID' },
            { label: 'LoanType', value: 'LoanType' },
            { label: 'PaymentPurpose', value: 'PaymentPurpose' },
            { label: 'ChargesBearBy', value: 'ChargesBearBy' },
            { label: 'MerchantID', value: 'MerchantID' },
            { label: 'FundingAccount', value: 'FundingAccount' },
            { label: 'ReceiptService', value: 'ReceiptService' },
            { label: 'RazorPayKey', value: 'RazorPayKey' },
            { label: 'RazorSecret', value: 'RazorSecret' },
            { label: 'IsActive', value: 'IsActive' },
            { label: 'CreatedBy', value: 'CreatedBy' },
            { label: 'isDeleted', value: 'isDeleted' },
            { label: 'CreatedOn', value: 'CreatedOn' },
            { label: 'SourceId', value: 'SourceId' },
            { label: 'SourceApplicationName', value: 'SourceApplicationName' },
          ],
          content: updatedData,
        },
      ];
      xlsx(data, settings);
    });
  }

  const handleAddButtonClick = () => {
    debugger;
    window.location.href = '/master/fundaccount/addfundaccount';
  };

  function handleReset(_e: any) {
    form.resetFields();
    let updatedFilter = { ...filter };
    updatedFilter = fundMappingFilter;
    setFilter(updatedFilter);
  }

  const handleStatusId = useCallback(
    (value: number) => {
      debugger;
      form.setFieldValue('loanType', value);
      setStatusId(value);
    },
    [form]
  );

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12">
          <div className="mid-container">
            <div className="submission-box">
              <h2>Fund Account Mapping</h2>
              <div className="submission-htmlForm">
                <Form<FundAccountFilter>
                  form={form}
                  onFinish={handleSubmit}
                  layout="vertical"
                  scrollToFirstError
                  className="standard-forms"
                  initialValues={{
                    ['Username']: sessionStorage.getItem('user')?.toString(),
                    ['SourceApplicationName']:
                      isAdmin != 'true' ? sessionStorage.getItem('source')?.toString() : null,
                  }}
                >
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Merchant ID :'} name="merchantId" className="fieldTitle">
                          <Input placeholder={'Merchant ID'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Funding Account :'}
                          name="fundingAccount"
                          className="fieldTitle"
                        >
                          <Input placeholder={'Funding Account'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Source Application Name:'}
                          name="sourceId"
                          className="fieldTitle"
                        >
                          <Select placeholder="Select" size="large">
                            {sourceAppNames.map((app) => (
                              <Option key={app.sourceId} value={app.sourceId}>
                                {app.sourceApplicationName}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Payment Purpose :'}
                          name="paymentPurpose"
                          className="fieldTitle"
                        >
                          <Select placeholder="Select" size="large">
                            <Option value="Fees">Fees</Option>
                            <Option value="Foreclosure">Foreclosure</Option>
                            <Option value="Overdue">Overdue</Option>
                            <Option value="OverdueWithoutCharges">Overdue Without Charges</Option>
                            <Option value="PartPayment">PartPayment</Option>
                            <Option value="ADVANCEEMI">Advance EMI</Option>
                            <Option value="OtherCharges">Other Charges</Option>
                            <Option value="Post Disbursement">Post disbursement</Option>
                            <Option value="VAS">VAS</Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Loan Type:'} name="loanType" className="fieldTitle">
                          <Select
                            placeholder="Select"
                            size="large"
                            value={loanType} // Set the value of the Select component
                            onChange={handleStatusId}
                          >
                            {statusList.map((status) => (
                              <Option key={status.sKey} value={status.sVlue}>
                                {status.sVlue}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Receipt Service :'}
                          name="receiptService"
                          className="fieldTitle"
                        >
                          <Select placeholder="Select" size="large">
                            <Option value="AllocatePayment">AllocatePayment</Option>
                            <Option value="EARLYSETTLEMENT">EARLYSETTLEMENT</Option>
                            <Option value="FEEPAYMENT">FEEPAYMENT</Option>
                            <Option value="IMD">IMD</Option>
                            <Option value="MANUALPAYMENT">MANUALPAYMENT</Option>
                            <Option value="PARTIALSETTLEMENT">PARTIALSETTLEMENT</Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Type :'} name="isActive" className="fieldTitle">
                          <Radio.Group
                            defaultValue={true}
                            onChange={(e) => form.setFieldsValue({ isActive: e.target.value })}
                          >
                            <label
                              className="btn btn-primary col-md-2"
                              style={{ marginRight: '10px', marginBottom: '20px' }}
                            >
                              <Radio
                                className="rblFeeType"
                                id="appTypeActive"
                                name="isActive"
                                type="radio"
                                value={true}
                                style={{ width: '600px', color: 'white', fontWeight: '' }}
                              >
                                Active
                              </Radio>
                            </label>
                            <label
                              className="btn btn-primary col-md-2"
                              style={{ marginRight: '10px', marginBottom: '20px' }}
                            >
                              <Radio
                                className="rblFeeType"
                                id="appTypeInactive" // Unique id for each radio button
                                name="isActive"
                                type="radio"
                                value={false}
                                style={{ width: '300px', color: 'white' }}
                              >
                                Inactive
                              </Radio>
                            </label>
                          </Radio.Group>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div style={{ marginBottom: '20px' }}>
                    <Button
                      type="link"
                      icon={<FileExcelFilled />}
                      style={{ float: 'right', fontSize: '30px', color: 'green' }}
                      onClick={handleDownload}
                    ></Button>
                    &nbsp; &nbsp;
                    <Button
                      type="primary"
                      onClick={handleReset}
                      style={{ float: 'right', marginRight: '5px' }}
                    >
                      {'CLEAR'}
                    </Button>
                    &nbsp; &nbsp;
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ float: 'right', marginRight: '10px' }}
                    >
                      {'SEARCH'}
                    </Button>
                    &nbsp; &nbsp;
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ float: 'right', marginRight: '10px' }}
                      onClick={handleAddButtonClick}
                    >
                      {'ADD'}
                    </Button>
                  </div>
                </Form>
              </div>
              <FundAccountList filter={{ ...filter }} onSubmit={handleSubmit} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filter;
